module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_3009.010deaa6.png";